import React, { useState, useEffect } from "react";
import { clientHistory } from "../../utils/enum/enums";
import { sortByText } from "../../utils/sort/sort";
import { IsAllow } from "../../utils/allowHelper/AllowHelper";
import HistoryFormFields from "../historyFormFields/HistoryFormFields";

const HistoryForm = ({
  type,
  setType,
  depositTypes,
  onSubmit,
  onCancel,
  isLoading,
  allow,
  translate,
}) => {
  const [comment, setComment] = useState("");
  const [amount, setAmount] = useState("");
  const [depositType, setDepositType] = useState("");
  const [options, setOptions] = useState([]);

  useEffect(() => {
    setOptions(
      sortByText([
        { id: clientHistory.DEPOSIT, text: translate("deposit") },
        { id: clientHistory.COMMENT, text: translate("comment") },
      ])
    );
  }, [translate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit({ type, comment, depositType, amount });
  };

  return (
    <form className="p-4 md:p-5 space-y-6" onSubmit={handleSubmit}>
      <div>
        <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          {translate("select-type")}
        </label>
        <select
          value={type}
          onChange={(e) => setType(e.target.value)}
          required
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg w-full p-2.5 dark:bg-gray-700 dark:text-white"
        >
          {options.map((option) =>
            option.id === clientHistory.DEPOSIT ? (
              IsAllow(allow, "SBFields") && (
                <option key={option.id} value={option.id}>
                  {option.text}
                </option>
              )
            ) : (
              <option key={option.id} value={option.id}>
                {option.text}
              </option>
            )
          )}
        </select>
      </div>

      <HistoryFormFields
        type={type}
        amount={amount}
        depositType={depositType}
        setAmount={setAmount}
        setDepositType={setDepositType}
        depositTypes={depositTypes}
        translate={translate}
      />

      <div>
        <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
          {translate("comment")}
        </label>
        <textarea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          required
          rows="4"
          className="w-full p-2.5 text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 dark:bg-gray-700 dark:text-white"
          placeholder={translate("comment-placeholder")}
        ></textarea>
      </div>

      <div className="flex justify-end gap-3">
        <button
          type="button"
          onClick={onCancel}
          disabled={isLoading}
          className="px-5 py-2.5 text-sm font-medium border rounded-lg bg-white hover:bg-gray-100 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700"
        >
          {translate("cancel")}
        </button>
        <button
          type="button"
          disabled={isLoading}
          className="px-5 py-2.5 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700"
          onClick={handleSubmit}
        >
          {translate("create-log")}
        </button>
      </div>
    </form>
  );
};

export default HistoryForm;
